import { ErrorType } from 'data/App/types'

import { TransactionsActions } from './actions'
import {
  FETCH_NEXT_TRANSACTIONS_PAGE,
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_ERROR,
  FETCH_TRANSACTIONS_SUCCESS
} from './actionTypes'
import { TransactionsResponse, TransactionType } from './types'

type PaymentInnerState = {
  data: TransactionsResponse
  error?: ErrorType
  loading: boolean
}
const INITIAL_STATE = {
  data: {
    items: [],
    next: null,
    prev: null
  },
  loading: false
}

// Example: { DEPOSIT: { loading: false, data: [] }, WITHDRAW: { loading: true } }
export type TransactionsState = Partial<Record<TransactionType, PaymentInnerState>>

const innerReducer = (state: PaymentInnerState = INITIAL_STATE, action: TransactionsActions) => {
  switch (action.type) {
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        data: { items: [], next: null, prev: null },
        loading: true
      }
    case FETCH_NEXT_TRANSACTIONS_PAGE:
      return {
        ...state,
        loading: true
      }
    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        data: {
          ...action.payload.transactions,
          items: [...state.data.items, ...action.payload.transactions.items]
        },
        loading: false
      }
    case FETCH_TRANSACTIONS_ERROR:
      return { ...state, error: action.payload.error, loading: false }
    default:
      return state
  }
}

export default (state: TransactionsState = {}, action: TransactionsActions) => {
  if (!action) return state
  const { type: paymentType } = action.payload
  if (!paymentType) return state
  return {
    ...state,
    [paymentType]: innerReducer(state[paymentType], action)
  }
}
